import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

const Container = styled.div`
  width: 1000px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  padding: var(--home-block-padding) 0;
  ${flexGap('16px')}
`;

const JetImg = styled.img`
  object-fit: cover;
`;

const DescBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  ${flexGap('20px')}
  background: #f4f6fc;
  padding: 24px;
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  line-height: normal;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${flexGap('32px')}
`;

const Desc = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  color: #424748;
`;

const Links = styled.div`
  display: flex;
  ${flexGap('16px')}
`;

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 41px;
  background: #fff;
  color: #424748;
  cursor: pointer;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    color: #050a30;
  }
`;

const ToCharter = styled(Link)`
  background: #1f68db;
  color: #fff;
  &:hover {
    color: #fff;
  }
`;

const ToPrivateJet = styled(Link)`
  background: #f4f6fc;
  color: #050a30;
  border: 1px solid #050a30;
  &:hover {
    color: #050a30;
  }
`;

const Book = () => {
  return (
    <Container>
      <JetImg
        src="/imgs/webp/home/book.webp"
        alt="Book the Perfect Private Jet for Your Flight"
      ></JetImg>
      <DescBox>
        <Title>
          Book the Perfect Private <br />
          Jet for Your Flight
        </Title>
        <Footer>
          <Desc>
            Whether you’re flying alone or you need an aircraft large enough to carry your entire
            organization, we’ll make sure that everyone has the room they need to fly comfortably
            and safely. From light aircraft to ultra-long-range jets, the Airacer team can help you
            book the right charter jet.
          </Desc>
          <Links>
            <ToCharter href="/charterQuote">Plan Your Flight</ToCharter>
            <ToPrivateJet href="/private-jets">Aircraft Types</ToPrivateJet>
          </Links>
        </Footer>
      </DescBox>
    </Container>
  );
};

export default Book;
